import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Helmet } from "react-helmet";
import {AlertProvider} from "./contexts/AlertContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <AlertProvider>
    <App />
      </AlertProvider>
    {/* <Helmet>
        <script src="/assets/plugins/global/plugins.bundle.js"></script>
       <script src="/assets/js/scripts.bundle.js"></script>
      </Helmet> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
